<template>
  <div>
    <div class="banner">
      <div class="userCon">
        <h1>如何注册成为心理亦笙用户？</h1>
        <p>注册完成才可进行心理咨询预约、心理测试和查看完整文章等操作</p>
      </div>
    </div>
    <div class="content userCon">
      <div class="left">
        <div class="select flex" @click="active=0" :class="{'active':active===0}">
          <img src="../../assets/img/pc.png" alt="" width="38">
          <strong>电脑端</strong>
        </div>
        <div class="select flex" @click="active=1" :class="{'active':active===1}">
          <img src="../../assets/img/mobilePhone.png" alt="" width="38">
          <strong>手机端</strong>
        </div>
      </div>
      <div class="right">
        <template v-if="active==0">
          <p><strong>第一步：</strong>点击右上角<span class="orange">【注册】</span>按钮</p>
          <img src="../../assets/img/userRes_a.png" alt="" width="911">
          <p class="mt"><strong>第二步：</strong>在弹窗中，选择注册身份<span class="orange">【普通用户注册】</span>，进入注册页面</p>
          <img src="../../assets/img/userRes_b.png" alt="" width="462">
          <p><strong>第三步：</strong>按照提示完成信息填写，点击<span class="orange">【下一步】</span>按钮</p>
          <img src="../../assets/img/userRes_c.png" alt="">
          <p class="step_three">
            ① 请输入您的【真实姓名】，便于医生了解您<br/>
            ② 请您选择获取注册验证码的方式【手机号码】【邮箱】<br/>
            注:海外用户请选择邮箱(Gmai账户除外)<br/>
            ③ 请输入您的手机号或邮箱，<span class="orange">【点击获取】</span>，展现图形验证码，并输入。<span
              class="orange">注：手机号或邮箱将成为您的登录【用户名】</span><br/>
            <img src="../../assets/img/userRes_d.png" class="mt_10" alt="" width="311"></p>
          <p class="mt_10 step_three">
            ④ 请输入图形验证码<br/>
            ⑤ 点击短信验证码项的<span class="orange">【点击获取】</span>验证码，请查收短信或邮件：【心理亦笙】注册验证码，并输入短信验证码<br/>
            ⑥ 请您阅读《用户注册协议》，如您没有异议请勾选：√我已阅读并同意<br/>
            ⑦ 请点击<span class="orange">【下一步】</span>
          </p>
          <p class="mt_20"><strong>第四步：</strong>设置登录密码，连续两次输入密码，点击<span class="orange">【注册】</span>按钮，完成注册</p>
          <div class="flex">
            <img src="../../assets/img/userRes_e.png" alt="" width="569">
            <p class="mt_50">
              ① 新用户需设置账户密码，并再次输入一次进行确认<br/>
              ② 请您阅读《用户注册协议》，<br/>
              如您没有异议请勾选：√我已阅读并同意<br/>
              ③ 点击<span class="orange">【注册】</span>，新用户注册完成！
            </p>
          </div>
        </template>
        <template v-else>
          <div class="flex userPh">
            <p><strong>第一步：</strong>在【首页】，点击右上角<span class="orange">【≡】</span>菜单符号，从右侧弹出菜单弹窗</p>
            <p><strong>第二步：</strong>在【菜单列表】中，点击<span class="orange">【立即登录】</span>按钮，进入登录页面</p>
            <p><strong>第三步：</strong>在【登录页面】，点击下侧<span class="orange">【还没有账号，去注册】</span>按钮，进入注册页面</p>
          </div>
          <img src="../../assets/img/userPhRes_a.png" alt="">
          <p><strong>第四步：</strong>在【注册页面】，按照提示完成信息填写，点击<span class="orange">【注册】</span>按钮，新用户注册完成！</p>
          <div class="flex">
            <img src="../../assets/img/userPhRes_b.png" alt="" width="67.5%">
            <div>
              <p>
                ① 请您选择获取注册验证码的方式【手机号码】【邮箱】<br/><span class="orange">注：海外用户请选择邮箱(Gmai账户除外)</span><br/>
                ② 请输入【真实姓名】，便于医生了解您<br/>
                ③ 请输入您的手机号或邮箱，<span class="orange">【点击获取】</span>，展现图形验证码并输入。<span
                  class="orange">注：手机号或邮箱将成为登录【用户名】</span><br/>
                ④ 请输入图形验证码<br/>
                <img src="../../assets/img/userRes_d.png" class="mt_10" alt="" width="311">
              </p>
              <p class="mt_10">
                ⑤ 点击短信验证码项的<span class="orange">【点击获取】</span>验证码，请查收短信或邮件：【心理亦笙】注册验证码，并输入短信验证码<br/>
                ⑥ 请您阅读《用户注册协议》，如您没有异议请勾选：√我已阅读并同意<br/>
                ⑦ 请点击<span class="orange">【注册】</span>，新用户注册完成！
              </p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "userRegister",
  data() {
    return {
      active: 0
    }
  },
  mounted() {
    $(".contentIndex").animate({scrollTop: '0px'}, 800);
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/userRegister';
</style>
